define('widgets/age',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.age', {

		options: {
			maxLength: 3
		},

		_create: function () {

			var maxLength = this.option('maxLength');
			this._on({
				'keydown': function (e) {
					// Allow: backspace, delete, tab, escape, enter and .
					if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
						 // Allow: Ctrl+A
						(e.keyCode == 65 && e.ctrlKey === true) ||
						 // Allow: home, end, left, right
						(e.keyCode >= 35 && e.keyCode <= 39)) {
							 // let it happen, don't do anything
							 return;
					}
					// Ensure that it is a number and stop the keypress
					if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
						e.preventDefault();
					}
				},
				'input': function () {
					this.element.val(this.element.val().slice(0, 3));
				}

			});

			return this._super();

		}

	});

});
